






































import Vue from "vue";

// Import External Components
import LayoutSection from "@miele/component-library-vue/src/components/layouts/LayoutSection.vue";
import LayoutFilter from "@miele/component-library-vue/src/components/layouts/LayoutFilter.vue";
import LayoutTeaserGrid from "@miele/component-library-vue/src/components/layouts/LayoutTeaserGrid.vue";
import TextLayerBeside from "@miele/component-library-vue/src/components/modules/content/image-block/TextLayerBeside.vue";
import TeaserTextLayer from "@miele/component-library-vue/src/components/elements/cards/TeaserTextLayer.vue";

// Import Components
import ResultsList from "@/components/ResultsList.vue";
import LoadMoreButtonContainer from "@/components/containers/LoadMoreButtonContainer.vue";

export default Vue.extend({
  name: "Index",
  components: {
    LayoutSection,
    TextLayerBeside,
    LayoutTeaserGrid,
    ResultsList,
    LoadMoreButtonContainer,
    TeaserTextLayer,
    LayoutFilter,
  },
  computed: {
    isLastPage() {
      return this.$store.getters.isLastPage;
    },
    translations() {
      return this.$store.state.translations;
    },
    name() {
      return this.$route.params.title;
    },
    recipes() {
      return this.$store.state.recipes.data;
    },
    headerImage() {
      return this.$store.state.currentRecipe?.image;
    },
  },
  async mounted() {
    this.$store.dispatch("addLoader");
    await this.loadCollection();
    await this.getSingleRecipe();
    this.$store.dispatch("removeLoader");
  },
  async beforeRouteLeave(to, from, next) {
    await this.$store.dispatch("resetTags");
    await this.$store.dispatch("fetchRecipes");
    await this.$store.dispatch("fetchGroups");
    next();
  },
  methods: {
    async loadCollection(): Promise<void> {
      const value = {
        name: this.$route.params.title,
        id: this.$route.params.id,
      };
      const tags = [];
      tags.push(value);
      await this.$store.dispatch("loadCollection", tags);
    },
    async getSingleRecipe() {
      const recipes = this.$store.state.recipes.data;
      const id =
        recipes[Math.floor(Math.random() * recipes.length)].recipe.id;
      await this.$store.commit("SET_SINGLE_RECIPE", null);
      await this.$store.dispatch("fetchSingleRecipe", id);
    },
    navigateBack(event: MouseEvent) {
      this.$router.push({
        name: "Index",
      });
      event.preventDefault();
    },
  },
});
